import { Button, Form, Input, Typography } from 'antd';
import saveAs from 'file-saver';
import moment from 'moment';
import { IDocument } from '../../interfaces';

const CmtToDownSell = ({
  setOpenEditSell,
  setShowDown,
  listClone,
  setOpenDownImg,
  statusSeller,
  isParentUpdate,
}: any) => {
  const OpenEdit = () => {
    setOpenEditSell(true);
    setShowDown(false);
  };
  const { Text } = Typography;

  const arrToMap: any[] = [listClone];
  const arrImg: any[] = [listClone?.documents];
  const downloadImage = () => {
    arrImg.forEach((element) => {
      for (let i = 0; i < element.length; i++) {
        saveAs(element[i].url, element[i].fileName);
      }
    });
  };

  const DownImgIndi = (id: number) => {
    arrImg.forEach((element) => {
      const item = element.filter((i: any) => i.id === id);
      saveAs(item[0].url, item[0].fileName);
    });
  };
  return (
    <div>
      {/* {arrToMap.map((item: any) => ( */}
      <div style={{ display: 'flex', gap: '10px' }}>
        <div className="attachUp" style={{ marginBottom: '10px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <>
              <p style={{ marginBottom: '0px' }}>Seller’s attachments</p>
            </>
            <Button
              type="primary"
              onClick={downloadImage}
              style={{
                cursor: 'pointer',
                background: '#3c3d5f',
                border: 'none'
              }}
            >
              Download
            </Button>
          </div>
          <div
            className="scrollImg"
            style={{
              height: '85px',
              overflowY: 'scroll',
              overflowX: 'scroll',
              width: '320px'
            }}
          >
            {listClone?.documents?.map((item: IDocument, index: any) => (
              <p
                key={index.toString()}
                style={{
                  marginBottom: '0px',
                  color: '#A6A6A6',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
                onClick={() => DownImgIndi(item.id)}
              >
                {item.fileName}
              </p>
            ))}
          </div>
        </div>
        <div className="commentCard" style={{ marginBottom: '10px' }}>
          <div
            className="wrapTitle"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <p>{listClone?.owner}</p>
            <p style={{ color: '#A3A3A3' }}>
              {moment(listClone?.updated_at)
                .utc()
                .format('YYYY-MM-DD hh:mm:ss A')}
            </p>
          </div>
          <Text>{listClone?.comment}</Text>

          {'edit' && !isParentUpdate ? (
            <div
              className="btn-edit"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end'
              }}
            >
              <Button
                onClick={OpenEdit}
                htmlType="submit"
                type="primary"
                disabled={statusSeller === 'SellerApproved' ?? true}
                style={{
                  background: '#F8F9FE',
                  border: '#D9D9D9',
                  color: 'black',
                  borderRadius: '7px'
                }}
              >
                Edit
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CmtToDownSell;
